export default __webpack_public_path__ + "static/media/web.5ac439f7.png";